import React, { Component } from 'react';
import { Layout, Row } from 'antd';
import { find, propEq, omit } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import BackButton from 'components/common/elements/BackButton';
import { getProjects, getApplications } from 'actions/asyncActions';
import ApplicationForm from './ApplicationForm';
import Breakpoint from 'components/layout/Breakpoint.js';

@withAsyncActions({
    getProjects: getProjects.withOptions({ dispatchOnMount: true }),
    getApplications: getApplications
        .withPayload(({ match: { params } }) => params.project_id)
        .withOptions({ dispatchOnMount: true }),
})
export default class ProjectApplicationEdit extends Component {
    render() {
        const { project_id, id } = this.props.match.params;
        const { data: { applications = [] } } = this.props.getApplications;
        const { data: { projects = [] } } = this.props.getProjects;

        const project = find(propEq('id', Number(project_id)), projects);
        const application = find(propEq('id', Number(id)), applications);

        return !project || !application ? null : (
            <Layout className="project container page page-sm-no-m main-content">
                <Breakpoint min="sm">
                    <Row type="flex" className="m-b-30">
                        <BackButton />
                        <div className="application-title title-route m-l-30">
                            <span>Проект: {project.name}</span>
                            <span className="color-link">Заявка: {application.name}</span>
                            <span className="color-title weight-bold m-t-10">ID заявки: {application.id}</span>
                        </div>
                    </Row>
                </Breakpoint>
                <Breakpoint max="sm">
                    <Row className="m-b-30 xs-p-20">
                        <BackButton />
                    </Row>
                    <div className="application-title title-route xs-p-20 m-b-20">
                        <span>Проект: {project.name}</span>
                        <span className="color-link">Заявка: {application.name}</span>
                        <span className="color-title weight-bold m-t-10">ID заявки: {application.id}</span>
                    </div>
                </Breakpoint>
                <ApplicationForm
                    changelocation={{ location: project.region.name.toLowerCase() }}
                    isEdit={true}
                    project_id={project_id}
                    initialValues={{
                        ...omit(['files'], application),
                        files_ids: application.files.map(file => file.id),
                    }}
                    {...this.props}
                />
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/application/ProjectApplicationEdit.js